import { FlexLayoutModule } from '@angular/flex-layout';
import { SpinnerComponent } from './spinner.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [SpinnerComponent],
  imports: [
    CommonModule,
    FlexLayoutModule
  ],
  exports: [SpinnerComponent]
})
export class SpinnerModule { }
